import { render, staticRenderFns } from "./FeeScheduleRogerian.vue?vue&type=template&id=8f3b3c1c"
import script from "./FeeScheduleRogerian.vue?vue&type=script&lang=js"
export * from "./FeeScheduleRogerian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports